"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

exports.__esModule = !0;
exports.InternalContainer = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _reactRouterDom = require("react-router-dom");

var InternalContainer = (0, _styledComponents.default)(_reactRouterDom.Link).withConfig({
  displayName: "InternalContainer",
  componentId: "sc-1xpgf7g-0"
})(["text-decoration:underline;"]);
exports.InternalContainer = InternalContainer;